import React from "react";
import { Box, Typography } from "@material-ui/core";
import BackgroundBox from "../../../design-system/atoms/BackgroundBox";
import { ResponsiveTotal, ResponsiveText } from "./RepairFunnelFooter";
import { Product } from "../../../../types/product";
import useRepairBonusAmount from "../../../../hooks/useRepairBonusAmount";
import RepairBonusDrawer from "../../../design-system/organisms/RepairBonusDrawer/RepairBonusDrawer";
import { StyledTypographyPrice } from "./StyledTypographyPrice";
import { styled } from "@material-ui/core/styles";

interface TotalMobileDisplayProps {
  amount: number;
  products: Product[];
}

const StrikedPrice = styled(Typography)(({ theme }) => ({
  textDecoration: "line-through",
  color: theme.palette.text.noResult,
  fontSize: "12px",
  marginLeft: theme.spacing(1),
}));

export const TotalMobileDisplayComponent: React.FunctionComponent<TotalMobileDisplayProps> = ({ amount, products }) => {
  const bonusAmount = useRepairBonusAmount(products);
  const priceAfterBonus = amount + bonusAmount / 100;
  return (
    <Box>
      <Box fontWeight="500" mx={2}>
        <ResponsiveTotal mr={1} display="inline-block" style={{ verticalAlign: "top" }} lineHeight="32px">
          Total
        </ResponsiveTotal>
        <StyledTypographyPrice>{priceAfterBonus},00 €</StyledTypographyPrice>
        {bonusAmount !== 0 && <StrikedPrice display="inline">{amount},00€</StrikedPrice>}
      </Box>
      {bonusAmount !== 0 && (
        <BackgroundBox ml={2} mt={1} noBorder={true}>
          <ResponsiveText p={1}>
            <Box display="inline-block">
              Après <b>Bonus Réparation</b>
            </Box>
            <Box component="span" ml={1}>
              <RepairBonusDrawer displayWithInfoIcon={true} />
            </Box>
          </ResponsiveText>
        </BackgroundBox>
      )}
    </Box>
  );
};
